import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import PhaseEditForm from './../../elements/phases/form';
import Loading from "../../elements/loading";
//import PhasesAdd from './../../elements/phases/widget/phases_add';

class PhasesCreate extends Component {
	render() {
		const { phases } = this.props;
		return (
			phases.isFetching ? <Loading/>:<PhaseEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.reset('phases.edit');
		this.props.fetchModalities();
		this.props.documentsTypesShow();
	}
}

//export default BaseLayout(PhasesCreate, {title: 'Crear etapa'});
export default BaseLayout(PhasesCreate, {
	title: 'Crear Subproceso',
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/phases/create.jsx